var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4108_91704)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.75 6C6.75 5.58578 6.41422 5.25 6 5.25C5.58578 5.25 5.25 5.58578 5.25 6V15C5.25 15.4142 5.58578 15.75 6 15.75C6.41422 15.75 6.75 15.4142 6.75 15V6Z",
    fill: "#86BB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 6.375C9.41422 6.375 9.75 6.71078 9.75 7.125V13.875C9.75 14.2892 9.41422 14.625 9 14.625C8.58578 14.625 8.25 14.2892 8.25 13.875V7.125C8.25 6.71078 8.58578 6.375 9 6.375Z",
    fill: "#86BB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75 4.5C12.75 4.08578 12.4142 3.75 12 3.75C11.5858 3.75 11.25 4.08578 11.25 4.5V16.5C11.25 16.9142 11.5858 17.25 12 17.25C12.4142 17.25 12.75 16.9142 12.75 16.5V4.5Z",
    fill: "#86BB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 5.625C15.4142 5.625 15.75 5.96078 15.75 6.375V14.625C15.75 15.0392 15.4142 15.375 15 15.375C14.5858 15.375 14.25 15.0392 14.25 14.625V6.375C14.25 5.96078 14.5858 5.625 15 5.625Z",
    fill: "#86BB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 8.25C18.75 7.83578 18.4142 7.5 18 7.5C17.5858 7.5 17.25 7.83578 17.25 8.25V12.75C17.25 13.1642 17.5858 13.5 18 13.5C18.4142 13.5 18.75 13.1642 18.75 12.75V8.25Z",
    fill: "#86BB00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 0.75C2.76472 0.75 0.75 2.76472 0.75 5.25V15.75C0.75 18.2353 2.76472 20.25 5.25 20.25H9.03469L11.4356 22.9939C11.578 23.1566 11.7837 23.25 12 23.25C12.2163 23.25 12.422 23.1566 12.5644 22.9939L14.9653 20.25H18.75C21.2353 20.25 23.25 18.2353 23.25 15.75V5.25C23.25 2.76472 21.2353 0.75 18.75 0.75H5.25ZM2.25 5.25C2.25 3.59314 3.59314 2.25 5.25 2.25H18.75C20.4069 2.25 21.75 3.59314 21.75 5.25V15.75C21.75 17.4069 20.4069 18.75 18.75 18.75H14.625C14.4087 18.75 14.203 18.8434 14.0606 19.0061L12 21.361L9.93945 19.0061C9.79702 18.8434 9.59126 18.75 9.375 18.75H5.25C3.59314 18.75 2.25 17.4069 2.25 15.75V5.25Z",
    fill: "#86BB00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4108_91704"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/audio.70d474555d9e83bb40ec8d10fd8ba03f.svg";
export { ForwardRef as ReactComponent };